import { UseGetStoreData } from "../getStoreData/UseGetStoreData";

export const useEmergencyContact = () => {
  const { getTicketData, officeData } = UseGetStoreData();
  const getEmergencyContact = (emList: any) => {

    const MessageToList = emList?.map((el: any) => {
      return el.mobile || el.whatsappNumber;
    });
    return MessageToList?.length ? MessageToList : [];
  };
  const filterValidNumber = (waNum: any) => {
    const number = waNum.filter(
      (validNum: any) =>
        validNum !== undefined && validNum !== null && validNum !== "" && validNum !== "N/A"
    );
    const res = new Set([...number]);
    let uniqNum = [...res]
    return uniqNum;
  };
  let emergencyContact = getEmergencyContact(
    getTicketData?.patient?.emergencyContacts
  );
  const getTicketRaisedByNum = getTicketData?.ticketRaisedBy?.mobile;
  const getPatientNum = getTicketData?.patient?.mobile;
  const pocNumber = getTicketData?.poc?.mobile;
  if (getTicketData?.ticketRaisedBy?.whatsappNumber !== "N/A" && (getTicketData?.ticketRaisedBy?.whatsappNumber !== getTicketData?.ticketRaisedBy?.mobile)) {
    emergencyContact.push(getTicketData?.ticketRaisedBy?.whatsappNumber);
  }
  ///these only for company-qr // we are including the campus contacts to get update//
  const campusContacts = Array.isArray(getTicketData?.campusContacts) && getTicketData.campusContacts.length
    ? getEmergencyContact(getTicketData.campusContacts)
    : null;
  // console.log('campusContacts:', campusContacts);
  let messageContacts: string[] = [];
  if (getTicketData?.campusId) {
    messageContacts = (Array.isArray(officeData?.messageContacts) && officeData?.messageContacts.length) ? officeData?.messageContacts.map((el: any) => String(el.mobile.number)) : [];
  }
  //pocNum//
  //companyNum//for premise--flow;  
  // console.log('campusContacts:', campusContacts);
  emergencyContact.push(getTicketRaisedByNum, getPatientNum, pocNumber, ...(Array.isArray(campusContacts) ? campusContacts : []), ...messageContacts);
  const validContacts = filterValidNumber(emergencyContact);
  // console.log('validContacts:', validContacts);
  return { validContacts };
};
